<script lang="ts">
	import { defineComponent } from "vue";
	import BannerCampus from "../components/landing/BannerCampusSlider.vue";
    import FormarBloqueLanding from "../components/landing/FormarBloqueLanding.vue";
    import Oferta from "../components/landing/Oferta.vue";
    import Ubicacion from "../components/landing/Ubicacion.vue";
    import Instalaciones from "../components/landing/Instalaciones.vue";
    import Tour360 from "../components/landing/Tour360.vue";
	// import ModelosEducativos from "../components/landing/ModelosEducativos.vue";
	// import OfertaEducativa from "../components/landing/OfertaEducativa.vue";
	// import HumanitasMuchoMas from "@/components/HumanitasMuchoMas.vue";


	export default defineComponent({
		name: "CampusPresaMadin",
		components: {
			BannerCampus,
            FormarBloqueLanding,
            Oferta,
            Ubicacion,
            Instalaciones,
            Tour360
		},
		props: {
			campus: {
				type: String,
				required: true,
			},
			banner: {
				type: String,
				required: true,
			},
        },
        data() {
            return {
                currentImage: 0,
                currentImage2: 0,
                images: [
                    '/pagesImages/aulas-Chihuahua-1.webp',
                    '/pagesImages/aulas-Chihuahua-2.webp'
                ],
                images2: [
                    '/pagesImages/areas-naturales-Chihuahua.webp',
                    '/pagesImages/areas-naturales-Chihuahua-2.webp',
                    '/pagesImages/areas-naturales-Chihuahua-3.webp',
                ],
                alts: [
                    'Instalaciones de Campus Magno Chihuahua',
                    'Instalaciones de Campus Magno Chihuahua'
                ],
                alts2: [
                    'Jardines y fuentes de Campus Magno Chihuahua',
                    'Jardines y fuentes de Campus Magno Chihuahua',
                    'Jardines y fuentes de Campus Magno Chihuahua'
                ],
                imagesArray: [
                    "/pagesImages/encabezado-landing-Chihuahua-1.webp",
                    "/pagesImages/encabezado-landing-Chihuahua-2.webp",
                    "/pagesImages/encabezado-landing-Chihuahua-3.webp",
                ],
                altArray: [
                    "Fotos de campus Magno Chihuahua de noche",
                    "Fotos de campus Magno Chihuahua de noche",
                    "Fotos de campus Magno Chihuahua de noche",
                ],
                tour: [
                    { src:"/pagesImages/tour-Chihuahua-1.webp", title:"Tour virtual en Campus Magno Chihuahua"},
                    { src:"/pagesImages/tour-Chihuahua-2.webp", title:"Tour virtual en Campus Magno Chihuahua"},
                    { src:"/pagesImages/tour-Chihuahua-3.webp", title:"Tour virtual en Campus Magno Chihuahua"},
                    { src:"/pagesImages/tour-Chihuahua-4.webp", title:"Tour virtual en Campus Magno Chihuahua"},
                    { src:"/pagesImages/tour-Chihuahua-5.webp", title:"Tour virtual en Campus Magno Chihuahua"},
                    { src:"/pagesImages/tour-Chihuahua-6.webp", title:"Tour virtual en Campus Magno Chihuahua"},
                    { src:"/pagesImages/tour-Chihuahua-7.webp", title:"Tour virtual en Campus Magno Chihuahua"},
                    { src:"/pagesImages/tour-Chihuahua-8.webp", title:"Tour virtual en Campus Magno Chihuahua"},
                ],
                campusName: "CHIHUAHUA",
                campusType: "CAMPUS MAGNO",
                localidad: "Chihuahua",
                frase: "Los grandes resultados requieren grandes ambiciones",
                autor: "Heráclito",
            }
        },
        methods: {
            nextImage() {
                this.currentImage = (this.currentImage + 1) % this.images.length
            },
            nextImage2() {
                this.currentImage2 = (this.currentImage2 + 1) % this.images2.length
            }
        }
	});
</script>

<template>
	<!-- <BannerCampus :banner="banner"/> -->
    <BannerCampus :campusType="campusType" :campus="campusName" :localidad="localidad" :slider="imagesArray" :alt="altArray" :frase="frase" :autor="autor" :banner="banner" />
    <FormarBloqueLanding :frase="'Campus Magno Chihuahua'" :testo1="'Se consolida como una opción de excelencia académica y un espacio diseñado para transformar y mejorar la vida académica y profesional.'" :testo2="'Ubicado a un costado de la emblemática Presa El Rejón, este campus combina el estilo neoclásico y la modernidad de sus instalaciones en un entorno natural único.'" :testo3="'Se caracteriza por enfocarse en la experiencia del aprendizaje, la reflexión y el conocimiento, diseñando programas educativos para responder a las demandas del mercado actual orientado al crecimiento profesional.'" :img="'/pagesImages/una-mirada-Chihuahua.webp'" :alt="'Panorámica de Campus Magno Chihuahua de día'" class="mb-16" />
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Instalaciones</h2>
            <p class="text-center mb-8">Este campus combina modernas y funcionales instalaciones en un entorno inspirador, que se posiciona como una opción ideal<br class="lg:block hidden"> para quienes buscan construir un futuro profesional sólido en un entorno educativo de alta calidad.</p>
            <div class="flex flex-col justify-between">
                <div class="lg:flex items-center justify-center mb-16">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Auditorio tipo teatro</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">El escenario perfecto para conferencias magistrales, presentaciones y eventos que enriquecen la formación integral de los estudiantes.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Aulas especializadas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Salones y espacios para asignaturas de Arquitectura; cámara Gesell y sala de juicios orales para prácticas profesionales de Psicología y Derecho.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Sala de cómputo de última generación</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Espacio con tecnología de avanzada, herramientas digitales y todo lo necesario para dominar las habilidades del futuro.</p>
                        </div>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images[currentImage]"
                        :alt="alts[0]"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                </div>
            </div>
            <div class="flex flex-col justify-between">
                <div class="flex lg:flex-row flex-col items-center justify-center">
                    <div class="flex lg:order-1 order-2 items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images2[currentImage2]"
                        :alt="alts2[0]"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage2"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                    <div class="lg:w-[50%] order-1 lg:order-2 text-justify mb-8 lg:mb-0 lg:ml-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Áreas naturales únicas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Cuenta con una ciclopista que rodea el área natural de la Presa El Rejón, que ofrece una vista espectacular, ideal para realizar actividades recreativas como recorridos, caminatas y kayak.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Aulas interactivas y climatizadas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Los salones cuentan con proyectores y sistemas de audio para clases dinámicas e interactivas, así como minisplits para aire caliente y frío, asegurando un ambiente cómodo en cualquier estación del año.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Biblioteca y recursos digitales</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Con acceso a libros físicos, bases de datos digitales y computadoras; la biblioteca fomenta el estudio en un entorno cómodo y bien equipado.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="grid lg:grid-cols-2 grid-cols-1 gap-10">
                
            </div> -->
        </div>
    </div>
    <h2 class="text-hgold text-center font-serif md:text-[42px] text-[32px] lg:px-0 px-8 lg:mb-4 leading-none w-full">Oferta académica en<br class="lg:block hidden"> Campus Magno Chihuahua</h2>
    <Oferta :virtual=false :visibleOffers="{
        Licenciaturas: ['Administración', 'Contabilidad', 'Derecho', 'Psicología' ],
        Maestrías: ['Alta Dirección', 'Contabilidad', 'Psicoterapia con un<br> enfoque Psicoanalítico'],
    }" class="flex items-center justify-center" />

    <div class="flex items-center justify-center w-full mb-16 mt-6 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-16 leading-none w-full">Nuestros modelos educativos</h2>
            <section class="flex items-center justify-center w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/mujer-modelo-ejecutivo-universidad-humanitas.webp" alt="Modelo ejecutivo en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
                            </div>
                            <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                                <h3>
                                    <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                    <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo ejecutivo</span>
                                </h3>
                                <p class=" lg:hyphens-none hyphens-auto">
                                    Está diseñado para brindar flexibilidad sin comprometer la calidad académica. Los programas se estructuran en bloques trimestrales, cada uno fusionando tres materias, impartidas por especialistas. Requiere autodisciplina, gestión eficiente del tiempo y compromiso con el éxito académico.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- <section class="flex items-center justify-center w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/vasos-cafe-despierta.webp" alt="Vasos de café de Despierta" class="w-full lg:max-w-[520px]"/>
                            </div>
                            <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                                <h3>
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo Escolarizado</span>
                                </h3>
                                <p class="">
                                    Ofrece una formación académica de calidad con un enfoque práctico y humano. Cada licenciatura está diseñada con objetividad e integrada con talleres y seminarios, que potencian la preparación para enfrentar los desafíos del mundo actual con conocimiento, habilidades y experiencia.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section> -->
        </div>
    </div>
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Tour virtual</h2>
            <p class="mb-10">Conoce el Campus Magno Chihuahua en nuestro tour virtual.</p>
            <Tour360 :src="'https://tourmkr.com/F1WqukSH6f'"  class="w-full mb-12"/>
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-10 leading-none w-full">Galería</h2>
            <Instalaciones :items="tour" class="" />
        </div>
    </div>

	<Ubicacion :campus="'Campus Magno Chihuahua'" :mapa="'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3502.424335188668!2d-106.1289723!3d28.6170418!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86ea5df01216bf43%3A0x26b1f3c3183f6a4f!2sUniversidad%20Humanitas%20Campus%20Chihuahua!5e0!3m2!1ses-419!2smx!4v1740425199099!5m2!1ses-419!2smx'" :testo1="'Llegar al Campus Magno Chihuahua es sencillo y accesible, gracias a su ubicación estratégica: la estación más cercana se encuentra en el Hospital Ángeles de Chihuahua. Las rutas de transporte público que dan acceso a esta zona son:'" :testo2="'● Panamericana Mirador.<br>● Circunvalación 2 (Sube Salle).<br>● Circunvalación 1 (Sube Zarzo y Campesina Sector 3).'" :ubicacion="'Dirección: Sendero Parque El Rejón S/N,Colonia: Presa El Rejón, C.P. 31629 Chihuahua.'" :telefono="'614 858 0000'" class="lg:px-0 px-8" />
</template>

<style scoped>
</style>
